import { AppointmentTypeSelection } from './calendar';
import { Option } from '../data';

export enum FilterOptionsType {
  ASSIGNED_TO = 'assignedTo',
  ISSUES = 'numberOfIssues',
}

export type FilterAction =
  | {
      payload: Option[];
      type: FilterOptionsType.ASSIGNED_TO;
    }
  | {
      payload: { numberOfResubmitted: number; numberOfSubmitted: number };
      type: FilterOptionsType.ISSUES;
    };

export type FilterContextType = {
  filterOptions: {
    clientOptions: Option[] | undefined;
    craftsmenOptions: Option[] | undefined;
    teamOptions: Option[] | undefined;
  };
  filters: {
    client: Option | undefined;
    craftsmen: Option | undefined;
    isAssignedToMe: boolean;
    isResubmitted: boolean;
    isScheduledForToday: boolean;
    isSubmitted: boolean;
    team: Option | undefined;
    workCategory: Option | undefined;
    workGroup: Option | undefined;
    workOrder: Option | undefined;
  };
  setFilterOptions: {
    setClientOptions: (input: Option[] | undefined) => void;
    setCraftsmenOptions: (input: Option[] | undefined) => void;
    setTeamOptions: (input: Option[] | undefined) => void;
  };
  setFilters: {
    setAssignedToMe: (input: boolean) => void;
    setClient: (input: Option | undefined) => void;
    setCraftsmen: (input: Option | undefined) => void;
    setResubmitted: (input: boolean) => void;
    setScheduledForToday: (input: boolean) => void;
    setSubmitted: (input: boolean) => void;
    setTeam: (input: Option | undefined) => void;
    setWorkCategory: (input: Option | undefined) => void;
    setWorkGroup: (input: Option | undefined) => void;
    setworkOrder: (input: Option | undefined) => void;
  };
};

export type DateRange = {
  from: Date | undefined;
  to?: Date | undefined;
};

export type FiltersState = {
  appointmentTypes?: Option[];
  assignedTo?: number;
  dateRange?: DateRange;
  isResubmitted?: boolean;
  isSubmitted?: boolean;
};

export type OrderPmFiltersState = {
  branch?: number;
  createdAtEndUtc?: Date;
  createdAtStartUtc?: Date;
  productId?: number;
  qualityManagerId?: number;
  search?: string;
};

export type UserFiltersState = {
  appointmentTypes?: Option[];
  branch?: number;
  notAfterUtc?: Date;
  notBeforeUtc?: Date;
  query?: string;
  team?: number;
};

export type FileFiltersState = {
  folderId?: number;
};
export type TeamFiltersState = {
  branch?: string;
  includeDeleted?: boolean;
};

export type CalendarFiltersState = {
  appointmentType?: Option<AppointmentTypeSelection>[];
  binding?: string;
  branch?: Option[];
  isOpen?: boolean;
  notAfterUtc?: Date;
  notBeforeUtc?: Date;
  partner?: Option[];
  person?: Option[];
  query?: string;
  team?: Option[];
};
